import { createQueryKeys } from '@lukemorales/query-key-factory';
import { type MaybeRefOrGetter, toValue } from 'vue';

import { getCurrentUserInvitations, getInvitation, getInvitations } from '../api';

export const invitationsKeys = createQueryKeys('invitations', {
  invitation: (accountUuid: MaybeRefOrGetter<string>, invitationUuid: MaybeRefOrGetter<string>) => ({
    queryKey: [accountUuid, invitationUuid],
    queryFn: (options) => getInvitation(toValue(accountUuid), toValue(invitationUuid), options),
  }),
  currentUserInvitations: {
    queryKey: null,
    queryFn: (options) => getCurrentUserInvitations(options),
  },
  invitations: {
    queryKey: null,
    queryFn: (options) => getInvitations(options),
  },
});
